<div class="app-password-input">
  <input
    [id]="id"
    [name]="name"
    [type]="visible ? 'text' : 'password'"
    class="form-control app-password-input__field"
    [placeholder]="placeholder"
    [autocomplete]="autocomplete"
    [disabled]="disabled"
    [value]="value"
    (input)="handleInput($any($event.target).value)"
    (blur)="onTouched()"
  />
  <button
    type="button"
    class="app-password-input__toggle"
    [attr.aria-label]="toggleAriaLabel"
    [attr.aria-pressed]="visible"
    (click)="toggleVisibility()"
  >
    @if (iconSet === 'icofont') {
      <!-- padrão KT (login): olho riscado = senha oculta, olho aberto = senha visível -->
      <i class="icofont" [class.icofont-eye-blocked]="!visible" [class.icofont-eye]="visible" aria-hidden="true"></i>
    } @else {
      <i class="fas" [class.fa-eye]="!visible" [class.fa-eye-slash]="visible" aria-hidden="true"></i>
    }
  </button>
</div>
